var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#DC625C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 9.0625C7.50937 9.0625 7.3125 9.25937 7.3125 9.5V10.1043L12.0293 13.9762C12.5953 14.441 13.4074 14.441 13.9734 13.9762L18.6875 10.1043V9.5C18.6875 9.25937 18.4906 9.0625 18.25 9.0625H7.75ZM7.3125 11.8023V16.5C7.3125 16.7406 7.50937 16.9375 7.75 16.9375H18.25C18.4906 16.9375 18.6875 16.7406 18.6875 16.5V11.8023L14.8047 14.9906C13.7547 15.852 12.2426 15.852 11.1953 14.9906L7.3125 11.8023ZM6 9.5C6 8.53477 6.78477 7.75 7.75 7.75H18.25C19.2152 7.75 20 8.53477 20 9.5V16.5C20 17.4652 19.2152 18.25 18.25 18.25H7.75C6.78477 18.25 6 17.4652 6 16.5V9.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.31f9c406ef9798237e28687b86282d32.svg";
export { ForwardRef as ReactComponent };